import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { Session } from '@diana/contracts';
import { ClientAvatar } from './ClientAvatar.js';
import { ClientContactRows } from './ClientContactRows.js';
import { clientContacts, internationalPhone } from './client-contacts.js';
import { giftPeopleOrder } from './crm-format.js';
import { GiftRoleLabels } from './GiftContactRoles.js';
export function GiftShootPeople({ shoot, action }: { shoot: Session; action: ReactNode }) {
  const roles = shoot.giftContacts!;
  const ids = giftPeopleOrder(shoot.status, roles);
  const others = shoot.clients.filter((person) => !ids.includes(person.id));
  return (
    <div className="gift-shoot-people">
      {ids.flatMap((id) => {
        const person = shoot.clients.find((client) => client.id === id);
        if (!person) return [];
        const contacts = clientContacts(person);
        return [
          <div
            key={id}
            className="gift-shoot-person"
            data-person-role={id === roles.buyerId ? 'buyer' : 'recipient'}
          >
            <div className="shoot-client__heading">
              <ClientAvatar id={person.id} name={person.name} className="shoot-client__avatar" />
              <Link to={`/crm/clients/${person.id}`}>
                {person.name}
                <ChevronRight size={16} aria-hidden="true" />
              </Link>
              <GiftRoleLabels clientId={person.id} roles={roles} />
              {id === roles.recipientId ? action : null}
            </div>
            <ClientContactRows
              contacts={contacts}
              international={internationalPhone(person.phone)}
            />
            {!contacts.length ? <p className="shoot-page__muted">No contact details</p> : null}
          </div>,
        ];
      })}
      {!roles.recipientId ? <div className="gift-shoot-people__add">{action}</div> : null}
      {others.length ? (
        <details className="gift-shoot-people__others">
          <summary>Other participants · {others.length}</summary>
          {others.map((person) => (
            <Link key={person.id} to={`/crm/clients/${person.id}`}>
              {person.name}
            </Link>
          ))}
        </details>
      ) : null}
    </div>
  );
}
